import React from 'react';
import { useNavigate } from 'react-router-dom';

const MobileSubcategoryChip = ({ sub, isActive, onClick }) => {
  const base = 'px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors';
  const cls = isActive
    ? `${base} bg-orange-500 text-white`
    : `${base} bg-white text-gray-600 border border-gray-200`;
  return (
    <button onClick={onClick} className={cls} data-testid={`subchip-${sub.slug}`}>
      <span className="mr-1">{sub.emoji}</span>{sub.name}
    </button>
  );
};

const MobileSubcategoryBar = ({ currentCategory, currentSubcategory }) => {
  const navigate = useNavigate();
  if (!currentCategory) return null;
  const subs = currentCategory.subcategories || [];
  if (subs.length === 0) return null;

  return (
    <div className="lg:hidden overflow-x-auto pb-3 -mx-4 px-4 mt-1" data-testid="mobile-subcategory-bar">
      <div className="flex gap-2 min-w-max">
        <button
          onClick={() => navigate(`/catalogue/${currentCategory.slug}`)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${!currentSubcategory ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200'}`}
          data-testid="subchip-all"
        >
          Tous
        </button>
        {subs.map((sub) => (
          <MobileSubcategoryChip
            key={sub.id}
            sub={sub}
            isActive={currentSubcategory?.id === sub.id}
            onClick={() => navigate(`/catalogue/${currentCategory.slug}/${sub.slug}`)}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileSubcategoryBar;
